/** Transformuje VIN, aby splňovalo formát:
 * - Všechny znaky jsou velká písmena
 * - Písmeno I je nahrazeno číslicí 1
 * - Pismena O a Q jsou nahrazena číslicí 0
 */
export function transformVIN(vin: string | null | undefined): string | null | undefined {
    if (!vin) return vin

    return vin.toUpperCase()
        .replace(/I/g, '1')
        .replace(/[OQ]/g, '0')
        .trim()
}